/**
 * Copyright (c) 2018, salesforce.com, inc.
 * All rights reserved.
 * Licensed under the BSD 3-Clause license.
 * For full license text, see LICENSE.txt file in the repo root or
 * https://opensource.org/licenses/BSD-3-Clause
 */
import React from 'react';
import _ from 'lodash';
import styled from 'styled-components';

import Localized from '../../../shared/components/Localized';
import Modal, { ModalHeader } from '../../components/Modal';


const List = styled.div`
  display: flex;
  flex-wrap: wrap;
  padding: 2rem;
`;

const Locale = styled.a`
  width: 50%;
  margin-bottom: 1rem;
  border: none;
  color: #0070d2;
  font-size: .875rem;
  font-weight: 400;
  text-align: center;
  background-color: white;
`;


class LocalePickerModal extends React.Component {

  onClick = (locale) => {
    this.props.changeLocale(locale);
    this.props.onClose(locale);
  }


  render() {
    if (!this.props.requests.locales.isCompleted) return null;
    return (
      <Modal onClose={this.props.onClose}>
        <ModalHeader>
          <Localized
            modelName='languageModal'
            modelKey='languagePicker'
            modelAttribute='label'
          />
        </ModalHeader>
        <List>
          {this.props.requests.locales.value.map((locale) => {
            return <Locale onClick={() => this.onClick(locale.code)}>{locale.name}</Locale>;
          })}
        </List>
      </Modal>
    );
  }
}

export default LocalePickerModal;

